import Checked from '@/assets/checked.png'
import styles from './index.module.less'
import { Tooltip } from 'antd'
import { useEffect, useState } from 'react'
interface IProps {
  data: any[]
  generalId: string // 通项id
  setGeneralId: (id: string) => void
  type: string // 区分类型
}
export default function GeneralList(props: IProps) {
  const { data, generalId, setGeneralId, type } = props
  const [active, setActive] = useState<any>(-1)
  useEffect(() => {
    console.log(generalId);
    
    setActive(generalId)
  }, [generalId])
  const onChangeGeneral = id => {
    setActive(id)
    setGeneralId(id)
  }
  return (
    <div className={styles.generalListContainer}>
      {type !== 'ACTIVITY' && <div className={styles.generalListContainer_title}>通项</div>}
      <div className={styles.generalListContainer_ListBox}>
        {data?.map((item: any) => {
          return (
            <div
              className={`${styles.generalListContainer_ListBox_item} ${active === item?.id ? styles.ListBox_item_active : ''}`}
              onClick={() => onChangeGeneral(item?.id)}
            >
              <Tooltip title={item?.name} placement="topLeft">
                <div className={styles.item_title}>{item?.name}</div>
              </Tooltip>
              {item?.chooseFlag && (
                <div className={styles.iconBox}>
                  <img src={Checked} alt="" />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
